import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../../core/authentication/authentication.service';
import { take } from 'rxjs/internal/operators/take';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SnackbarService } from '../../../../core/services/snack.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  standalone: false,
})
export class ResetPasswordComponent {
  form!: FormGroup;

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private formBuilder: FormBuilder,
    private snackbarService: SnackbarService,
  ) {
    this.form = this.formBuilder.group({
      username: [null, [Validators.required, Validators.minLength(3)]],
      email: [null, [Validators.required, Validators.email]],
    });
  }

  resetPassword() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { username, email } = this.form.value;

    this.authService
      .forgotPassword({ username: username, email: email })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.snackbarService.showSuccess('Recibirás un correo con los siguientes pasos.');
          this.router.navigate(['/login']);
        },
        error: () => {
          this.snackbarService.showError(
            'No se ha podido procesar la solicitud. Inténtalo de nuevo más tarde.',
          );
        },
      });
  }
}
